import React from 'react';
import { Text, View, Pressable, StyleSheet } from 'react-native';

import { __WEB__, COLOR, FONT, FONT_SIZE, THEME } from '../../../../constants/styles';

import { OPComponent } from '../../../components';

export const PATIENT_TYPE_WIDTH = __WEB__ ? 170 : 120;
export const NAME_WIDTH = 200;

export default class ListRow extends OPComponent {
  constructor(props) {
    super(props);
  }

  handleResidentTap = () => {
    const { data, handleResidentTap } = this.props;
    handleResidentTap(data.caseId);
  };

  render() {
    const { data, index } = this.props;
    const odd = index % 2 !== 0;

    if (!__WEB__)
      return (
        <View style={[styles.container, odd ? styles.alt : null]}>
          <View style={[THEME.basicRow, { alignItems: 'flex-start' }]}>
            <View style={styles.nameContainer}>
              <Pressable style={styles.nameButton} onPress={this.handleResidentTap}>
                <Text style={styles.linkStyle} numberOfLines={1} ellipsizeMode="tail">
                  {data.name}
                </Text>
              </Pressable>
            </View>
          </View>
        </View>
      );

    return (
      <View style={[styles.container, odd ? styles.alt : null]}>
        <View style={[THEME.basicRow, { alignItems: 'flex-start' }]}>
          <View style={styles.nameContainer}>
            <Pressable style={styles.nameButton} onPress={this.handleResidentTap}>
              <Text style={styles.linkStyle} numberOfLines={1} ellipsizeMode="tail">
                {data.name}
              </Text>
            </Pressable>
          </View>
          <View style={styles.patientTypeContainer}>
            <Text style={THEME.rowText}>{data?.patient?.role}</Text>
          </View>
        </View>
      </View>
    );
  }
}

const styles = StyleSheet.create({
  container: {
    paddingVertical: 15,
  },
  alt: {
    backgroundColor: COLOR.altContrast,
  },
  patientTypeContainer: {
    paddingLeft: 15,
    width: PATIENT_TYPE_WIDTH,
    flexGrow: 0.1,
    flexShrink: 1,
  },
  nameContainer: {
    flexGrow: 0.4,
    flexShrink: 1,
    paddingLeft: 15,
    width: NAME_WIDTH,
  },
  nameButton: {
    flex: 1,
    flexDirection: 'row',
  },
  linkStyle: {
    ...THEME.rowText,
    ...THEME.linkStyle,
    ...FONT.medium,
    textDecorationLine: 'underline',
  },
});
